module.exports = __webpack_public_path__ + "static/scale_mail-03e27174a4fbbc56336968b5c21872b4.jpg";